import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/admin/")({
  component: () => <Navigate to="/app/admin/approvals" />,
});
